import { createContext } from "react";

const SystemLanguagesContext = createContext(null);

export { SystemLanguagesContext };
